import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { Message } from '@clientwire/api';

export enum MessageType {
  Text = 'TEXT',
  LocationRequest = 'LOCATION_REQUEST',
  Location = 'LOCATION',
  Image = 'IMAGE',
  Event = 'EVENT',
  Typing = 'TYPING',
}

export enum MessageSenderType {
  Client = 'CLIENT',
  Bot = 'BOT',
  TenantUser = 'TENANT_USER',
}

export interface MessageButton {
  type: MessageButtonType;
  label?: string;
  icon?: IconProp;
  data?: any;
}

export enum MessageButtonType {
  LocationRequest = 'LOCATION_REQUEST',
  Checklist = 'CHECKLIST',
  CallBack = 'CALLBACK',
  Asset = 'ASSET',
  CopyCoordinates = 'COPY_COORDINATES',
  OpenGoogleMaps = 'OPEN_GOOGLE_MAPS',
}

export interface MessageButtonClickEvent {
  type: MessageButtonType;
  data?: any;
}

export enum MessageStateType {
  Sending = 'SENDING',
  Sent = 'SENT',
  Read = 'READ',
}
export type MessageUpdateEvent =
  | 'serverMessages'
  | 'loadingChange'
  | 'localMessage'
  | 'socketMessage'
  | 'init'
  | undefined;
export interface MessagesWithConversationId {
  id: string; // this is the conversationId
  lastUpdateEvent?: MessageUpdateEvent;
  messagePrependLoading?: boolean;
  messageAppendLoading?: boolean;
  messageIdsWithError: string[];
  messagesLimit: number;
  messages: Message[];
}
